import { proConstants } from "../constants/pro";

export function roles(state = {}, action) {
  let oldstate = state;
  let currentstate = false;

  switch (action.type) {
    case proConstants.ROLE_SAVE_REQUEST:
      currentstate = { insert_id: null, loading: true, error: null };
      break;
    case proConstants.ROLE_SAVE_SUCCESS:
      currentstate = {
        insert_id: action.data.insert_id,
        loading: false,
        update_required: true
      };
      break;
    case proConstants.ROLE_SAVE_FAILURE:
      currentstate = { error: action.error, loading: false };
      break;

    case proConstants.ROLE_GET_REQUEST:
      currentstate = { loading: true };
      break;
    case proConstants.ROLE_GET_SUCCESS:
      currentstate = { details: action.data, loading: false };
      break;
    case proConstants.ROLE_GET_FAILURE:
      currentstate = { error: action.error, loading: false };
      break;

    case proConstants.ROLE_LISTING_REQUEST:
      currentstate = {
        loading: true,
        paginationOptions: null,
        list: null,
        error: null,
        insert_id: null,
        update_required: null,
        details: null
      };
      break;
    case proConstants.ROLE_LISTING_SUCCESS:
      currentstate = {
        list: action.data,
        paginationOptions: action.paginationOptions,
        loading: false
      };
      break;
    case proConstants.ROLE_LISTING_FAILURE:
      currentstate = { error: action.error, loading: false };
      break;

    case proConstants.ROLE_DELETE_REQUEST:
      currentstate = { loading: true, error: null };
      break;
    case proConstants.ROLE_DELETE_SUCCESS:
      currentstate = { loading: false, update_required: true };
      break;
    case proConstants.ROLE_DELETE_FAILURE:
      currentstate = { error: action.error, loading: false };
      break;

    default:
      break;
  }

  if (!!currentstate) {
    return { ...oldstate, ...currentstate };
  } else {
    return oldstate;
  }
}
